import wretchAdapter from '@/shared/api/adapters/wretch';

export default wretchAdapter(CONFIG.LOGIN_API_ROOT);
